import React from 'react';
import { paraFormat } from '../utils/fiyat';

// TOPLAM / KDV (%X'e göre bir veya daha fazla satır) / G.TOPLAM özeti — Kabul İşlemleri ve Fiyat Ver
// ortak kullanır (kullanıcı talebi: 2026-08-09). Etiket hücreleri koyu zemin renginde, G.TOPLAM daha
// vurgulu — kullanıcının VB6 uygulamasındaki kümülatif kutusundan esinlenilmiş tablo görünümü
// (kullanıcı talebi: 2026-08-09).
export default function KumulatifOzet({ toplam, kdvGruplari, gToplam }) {
  const etiketStil = { background: 'var(--med-dark)', color: '#fff', fontWeight: 600, padding: '7px 16px', textAlign: 'left' };
  const degerStil = { background: 'var(--med-light)', color: 'var(--med-dark)', fontWeight: 600, padding: '7px 16px', textAlign: 'right' };

  return (
    <div style={{ marginTop: 12, display: 'flex', justifyContent: 'flex-end' }}>
      <table style={{ borderCollapse: 'collapse', minWidth: 260, fontSize: 13, borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.12)' }}>
        <tbody>
          <tr>
            <td style={etiketStil}>TOPLAM</td>
            <td style={degerStil}>{paraFormat(toplam)}</td>
          </tr>
          {kdvGruplari.map(g => (
            <tr key={g.yuzde}>
              <td style={etiketStil}>KDV %{g.yuzde}</td>
              <td style={degerStil}>{paraFormat(g.tutar)}</td>
            </tr>
          ))}
          <tr>
            <td style={{ background: 'var(--med-accent)', color: '#fff', fontWeight: 700, fontSize: 15, padding: '9px 16px', textAlign: 'left' }}>G.TOPLAM</td>
            <td style={{ background: 'var(--med-accent)', color: '#fff', fontWeight: 700, fontSize: 15, padding: '9px 16px', textAlign: 'right' }}>{paraFormat(gToplam)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
